import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getUser } from 'src/api/stoApi';
import { IUser } from 'src/models';
import { generalStore } from 'src/stores/GeneralStore';

export const useUser = () => {
  const [user, setUser] = useState<IUser | null>(null);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        const response = await getUser();
        setUser(response.data.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    load();
  }, []);

  return user;
};
